import { inject, excutePlugins } from "./install"
const sleep = time => new Promise(resolve => setTimeout(resolve, time));
export { inject, excutePlugins, sleep } 
